// extracted by mini-css-extract-plugin
export default {"formWrapper":"style_formWrapper__PQ5Ym"};